(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-buy-buttons"] && !Shopify.designMode) return;
  try {
    /* the bar covers the bottom of the viewport, so publish its measured height
     for anything that has to sit clear of it (the chat widget). It measures 0
     once the bar is hidden from 750px up, which zeroes the offset by itself. */
  const stickyBar = document.querySelector('.product__sticky-bar');

  if (stickyBar) {
    new ResizeObserver(([entry]) => {
      document.documentElement.style.setProperty('--sticky-bar-height', `${entry.target.offsetHeight}px`);
    }).observe(stickyBar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-highlights"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('citrus-highlights')) {
    customElements.define(
      'citrus-highlights',
      class CitrusHighlights extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.product-highlights__track');
          this.prev = this.querySelector('.product-highlights__arrow--prev');
          this.next = this.querySelector('.product-highlights__arrow--next');
          if (!this.track || !this.prev || !this.next) return;

          this.onPrev = () => this.step(-1);
          this.onNext = () => this.step(1);
          this.onScroll = () => this.schedule();

          this.prev.addEventListener('click', this.onPrev);
          this.next.addEventListener('click', this.onNext);
          this.track.addEventListener('scroll', this.onScroll, { passive: true });

          // covers window resize, browser zoom and the sticky column narrowing,
          // which a resize listener on window would all miss or mistime
          this.observer = new ResizeObserver(() => this.schedule());
          this.observer.observe(this.track);

          this.update();
        }

        disconnectedCallback() {
          if (this.prev) this.prev.removeEventListener('click', this.onPrev);
          if (this.next) this.next.removeEventListener('click', this.onNext);
          if (this.track) this.track.removeEventListener('scroll', this.onScroll);
          if (this.observer) this.observer.disconnect();
          if (this.frame) cancelAnimationFrame(this.frame);
          this.frame = null;
        }

        schedule() {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.update();
          });
        }

        step(direction) {
          const entry = this.track.firstElementChild;
          if (!entry) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          this.track.scrollBy({ left: direction * (entry.getBoundingClientRect().width + gap) });
        }

        update() {
          const max = this.track.scrollWidth - this.track.clientWidth;
          // at any zoom other than 100% the widths turn fractional and a strip
          // with nothing to scroll still reports a sub-pixel overflow
          const scrollable = max > 1;

          this.prev.hidden = !scrollable;
          this.next.hidden = !scrollable;

          if (!scrollable) {
            // coming back to the desktop grid, a leftover offset would shift the rows
            if (this.track.scrollLeft !== 0) this.track.scrollLeft = 0;
            return;
          }

          this.prev.disabled = this.track.scrollLeft <= 1;
          this.next.disabled = this.track.scrollLeft >= max - 1;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-variant-picker"] && !Shopify.designMode) return;
  try {
    // Per-option variant picker: recompose the selected variant from each option
  // group and keep the hidden `id` input (and price) in sync.
  //
  // Everything it drives lives in sibling blocks whose order the merchant
  // controls, so nothing is cached at connect time: the element may upgrade
  // while later blocks are still being parsed. Every reference is a lazy getter
  // resolved from the product id.
  if (!customElements.get('variant-selects')) {
    customElements.define(
      'variant-selects',
      class VariantSelects extends HTMLElement {
        connectedCallback() {
          this.variants = JSON.parse(this.querySelector('[data-variant-data]').textContent);
          this.positions = [...new Set([...this.radios()].map((r) => +r.dataset.optionPosition))].sort(
            (a, b) => a - b
          );
          this.addText = this.dataset.addText;
          this.soldoutText = this.dataset.soldoutText;
          this.addEventListener('change', () => this.update());
          // the buy-buttons block may still be parsing; wait for the full document
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.initFromUrl(), { once: true });
          } else {
            this.initFromUrl();
          }
        }

        get form() {
          return document.getElementById('product-form-' + this.dataset.productId);
        }

        get idInput() {
          return this.form?.querySelector('[data-variant-id]');
        }

        get quantity() {
          return this.form?.querySelector('[data-quantity]');
        }

        get buyNow() {
          return this.form?.querySelector('[data-buy-now]');
        }

        get gallery() {
          return document.getElementById('carousel-' + this.dataset.productId);
        }

        // Preselect from ?variant=<id> if present; otherwise leave the picker
        // empty (no auto-selected variant on a clean landing).
        initFromUrl() {
          const params = new URLSearchParams(location.search);
          const id = params.get('variant');
          const variant = id && this.variants.find((v) => String(v.id) === id);
          // the id stays the primary source: it is what the server resolves too.
          // The readable slugs only cover links without an id, or with an id that
          // no longer exists, even when they describe just some of the options.
          if (variant) this.selectVariant(variant);
          else this.selectFromSlugs(params);
          this.update();
        }

        // Check the radios whose slug appears in the query string. Tolerates a
        // partial selection: update() recomputes availability and price anyway.
        selectFromSlugs(params) {
          for (const radio of this.radios()) {
            if (radio.dataset.valueSlug && params.get(radio.dataset.optionKey) === radio.dataset.valueSlug) {
              radio.checked = true;
            }
          }
        }

        selectVariant(variant) {
          for (const p of this.positions) {
            [...this.radios(p)].forEach((r) => {
              r.checked = r.value === variant.options[p - 1];
            });
          }
        }

        // Prices render in their own block and in the sticky bar, so they are
        // looked up on demand rather than cached.
        get priceEls() {
          return document.querySelectorAll(
            `[data-price-dynamic][data-section="${this.dataset.productId}"]`
          );
        }

        get badgeEls() {
          return document.querySelectorAll(
            `[data-badge-dynamic][data-section="${this.dataset.productId}"]`
          );
        }

        get shippingBannerEls() {
          return document.querySelectorAll(
            `[data-shipping-banner][data-section="${this.dataset.productId}"]`
          );
        }

        get addBtns() {
          const form = this.form;
          return [
            ...(form?.querySelectorAll('button[type="submit"]') ?? []),
            ...document.querySelectorAll(`button[form="${form?.id}"]`),
          ];
        }

        radios(position) {
          const sel =
            position == null
              ? 'input[type="radio"]'
              : `input[data-option-position="${position}"]`;
          return this.querySelectorAll(sel);
        }

        selected() {
          const s = {};
          this.querySelectorAll('input[type="radio"]:checked').forEach((r) => {
            s[r.dataset.optionPosition] = r.value;
          });
          return s;
        }

        // Given the earlier options' selection, classify each option value:
        //  - inexistent (no variant) -> hidden (display:none)
        //  - exists but no stock     -> shown, struck-through, not selectable
        //  - available               -> normal. Cascades left to right.
        updateAvailability() {
          const sel = this.selected();
          for (const p of this.positions) {
            const radios = [...this.radios(p)];
            for (const radio of radios) {
              const match = (v, needAvail) =>
                (!needAvail || v.available) &&
                this.positions.every((q) => {
                  // constrain by earlier options only when they are chosen
                  if (q < p) return sel[q] == null || v.options[q - 1] === sel[q];
                  if (q === p) return v.options[q - 1] === radio.value;
                  return true;
                });
              const exists = this.variants.some((v) => match(v, false));
              const available = this.variants.some((v) => match(v, true));
              const pill = radio.closest('.variant-pill');
              if (pill) {
                pill.classList.toggle('is-hidden', !exists);
                pill.classList.toggle('is-soldout', exists && !available);
              }
              radio.disabled = !available; // can't pick a value with no stock
            }
            // only if an already-chosen value became impossible, move it to a
            // valid one. Never auto-select an untouched group (empty landing).
            const checked = radios.find((r) => r.checked);
            if (checked && (checked.closest('.variant-pill')?.classList.contains('is-hidden') || checked.disabled)) {
              const next =
                radios.find((r) => !r.disabled) ||
                radios.find((r) => !r.closest('.variant-pill')?.classList.contains('is-hidden'));
              checked.checked = false;
              if (next) {
                next.checked = true;
                sel[p] = next.value;
              } else {
                delete sel[p];
              }
            }
          }
        }

        setVariant() {
          const chosen = [...this.querySelectorAll('input[type="radio"]:checked')]
            .sort((a, b) => a.dataset.optionPosition - b.dataset.optionPosition)
            .map((r) => r.value);

          // incomplete selection: no purchasable variant yet, so price the variants
          // still reachable from what has been chosen. With nothing chosen that is
          // every variant, which reproduces the range rendered server-side.
          if (chosen.length !== this.positions.length) {
            const sel = this.selected();
            const candidates = this.variants.filter((v) =>
              this.positions.every((p) => sel[p] == null || v.options[p - 1] === sel[p])
            );
            this.renderPrice({ current: this.priceRange(candidates), compare: null, unit: null });
            this.renderBadge(this.badgeFor(candidates));
            this.renderShippingBanner(candidates);
            // with nothing chosen the candidates are every variant, and the
            // landing must stay on the product's featured image
            if (chosen.length) this.updateImage(candidates);
            const idInput = this.idInput;
            if (idInput) idInput.value = '';
            this.buyNow?.classList.add('is-hidden');
            this.quantity?.classList.remove('is-vanished');
            this.setAddButtons(true, this.addText);
            this.updateUrl(null);
            this.announce('', false);
            return;
          }

          const match = this.variants.find(
            (v) => v.options.every((o, i) => o === chosen[i])
          );
          if (!match) return;

          const idInput = this.idInput;
          if (idInput) idInput.value = match.id;
          this.renderPrice({ current: match.price, compare: match.compare, unit: match.unit });
          this.renderBadge(this.badgeFor([match]));
          this.renderShippingBanner([match]);
          this.setStock(match.available);
          this.updateImage([match]);
          this.updateUrl(match.id);
          this.announce(match.id, match.available);
        }

        // Everything above updates the DOM directly, but components outside this
        // block (the wishlist heart) need to know which variant is now current.
        announce(variantId, available) {
          document.dispatchEvent(
            new CustomEvent('citrus:variant:change', {
              detail: { productId: this.dataset.productId, variantId, available },
            })
          );
        }

        // Cheapest-to-priciest span of the given variants. Sold-out ones count, to
        // match the server-side product.price_min/price_max: the pills already say
        // what is out of stock.
        priceRange(candidates) {
          if (!candidates.length) return '';
          let min = candidates[0];
          let max = candidates[0];
          for (const v of candidates) {
            if (v.amount < min.amount) min = v;
            if (v.amount > max.amount) max = v;
          }
          // en dash separator — kept in sync with snippets/price.liquid
          return min.amount === max.amount ? min.price : `${min.price} – ${max.price}`;
        }

        // Single place that writes the price DOM, for every `.price` block of this
        // product (main one and sticky bar). A range carries neither a compare-at
        // price nor a unit price, so both are passed as null.
        renderPrice({ current, compare, unit }) {
          for (const el of this.priceEls) {
            const currentEl = el.querySelector('[data-price-current]');
            const compareEl = el.querySelector('[data-price-compare]');
            const saleLabel = el.querySelector('[data-price-sale-label]');
            const unitEl = el.querySelector('[data-price-unit]');
            const currentValue = el.querySelector('[data-price-current-value]');
            const compareValue = el.querySelector('[data-price-compare-value]');

            if (currentValue) currentValue.textContent = current;
            if (compareValue) compareValue.textContent = compare ?? '';
            currentEl?.classList.toggle('price__current--sale', Boolean(compare));
            if (compareEl) compareEl.hidden = !compare;
            if (saleLabel) saleLabel.hidden = !compare;
            if (unitEl) {
              unitEl.textContent = unit ?? '';
              unitEl.hidden = !unit;
            }
          }
        }

        // Badge for a set of candidate variants: sold out wins, then the exact
        // percentage when they all share it, then "up to" the highest one. With a
        // single candidate max === min, so a completed selection always gets the
        // real percentage — or nothing, when that variant is not on sale.
        //
        // The all-sold-out check is also what stops a fully unavailable product
        // from having its server-rendered "sold out" badge replaced by a discount.
        badgeFor(candidates) {
          if (!candidates.length) return { text: '', variant: 'sale' };
          if (candidates.every((v) => !v.available)) {
            return { text: this.dataset.badgeSoldout, variant: 'sold_out' };
          }
          const discounts = candidates.map((v) => v.discount);
          const max = Math.max(...discounts);
          if (!max) return { text: '', variant: 'sale' };
          const min = Math.min(...discounts);
          const template = max === min ? this.dataset.badgePercent : this.dataset.badgePercentUpTo;
          return { text: template.replace('@@', max), variant: 'sale' };
        }

        // Single place that writes the badge DOM. `hidden` needs the
        // .badge[hidden] rule in snippets/badge.liquid to actually take effect.
        renderBadge({ text, variant }) {
          for (const el of this.badgeEls) {
            el.textContent = text;
            el.hidden = !text;
            el.classList.toggle('badge--sale', variant === 'sale');
            el.classList.toggle('badge--sold_out', variant === 'sold_out');
          }
        }

        // Single place that writes the free shipping banner DOM. A partial
        // selection still spanning mixed variants must not promise anything, so
        // the banner only shows when every reachable candidate carries the flag.
        // `hidden` needs the [hidden] rule in _product-shipping-banner.liquid.
        renderShippingBanner(candidates) {
          const on = candidates.length > 0 && candidates.every((v) => v.freeShipping);
          for (const el of this.shippingBannerEls) el.hidden = !on;
        }

        setAddButtons(disabled, label) {
          for (const button of this.addBtns) {
            button.disabled = disabled;
            button.textContent = label;
          }
        }

        // every readable key the picker owns, so they can be cleared on each update
        get optionKeys() {
          return [...new Set([...this.radios()].map((r) => r.dataset.optionKey))];
        }

        // Reflect the selection in the URL without reloading: first the readable
        // pairs (?tipologia=moro&formato=5-kg) in option order, then ?variant=,
        // which stays the only parameter Shopify resolves server-side. A partial
        // selection still shows up, minus the variant id.
        //
        // Keys are cleared and rewritten rather than set in place: that is what
        // keeps them ordered and drops the ones no longer selected. Third-party
        // params already on the URL (utm_*, fbclid) are left untouched.
        updateUrl(id) {
          const url = new URL(location.href);
          this.optionKeys.forEach((key) => url.searchParams.delete(key));
          url.searchParams.delete('variant');

          const chosen = [...this.querySelectorAll('input[type="radio"]:checked')].sort(
            (a, b) => a.dataset.optionPosition - b.dataset.optionPosition
          );
          for (const radio of chosen) {
            url.searchParams.set(radio.dataset.optionKey, radio.dataset.valueSlug);
          }
          if (id) url.searchParams.set('variant', id);

          history.replaceState({}, '', url);
        }

        // The image every candidate shares, or none. A completed selection has a
        // single candidate, so this is simply that variant's image.
        sharedImage(candidates) {
          const ids = [...new Set(candidates.map((v) => v.image).filter(Boolean))];
          return ids.length === 1 ? ids[0] : null;
        }

        // Slide the gallery to the image of the selection. When the candidates
        // do not share one, or carry none at all, the gallery stays where it is.
        //
        // The slides are read from the DOM rather than from `swiper.slides` so
        // the lookup also works before Swiper exists: on a `?variant=` landing
        // this runs while the gallery is still inert (see goToSlide).
        updateImage(candidates) {
          const gallery = this.gallery;
          if (!gallery) return;
          const imageId = this.sharedImage(candidates);
          if (!imageId) return;
          const index = [...gallery.querySelectorAll('.swiper-slide')].findIndex(
            (slide) => slide.dataset.imageId === String(imageId)
          );
          if (index >= 0) this.goToSlide(gallery, index);
        }

        // On a `?variant=` landing this block runs before carousel.js has even
        // been evaluated, so <citrus-carousel> is not upgraded yet and has no
        // goTo(). Waiting for the definition is enough: connected elements are
        // upgraded synchronously inside customElements.define(), so goTo() runs
        // before the rAF in which the element builds its Swiper, and lands as
        // the initial slide rather than as a jump right after init.
        goToSlide(gallery, index) {
          if (typeof gallery.goTo === 'function') {
            gallery.goTo(index);
            return;
          }
          customElements
            .whenDefined('citrus-carousel')
            .then(() => gallery.goTo?.(index));
        }

        // Out-of-stock UI: hide quantity (animated) and buy-now, turn the CTA
        // into a disabled "sold out" label.
        setStock(available) {
          this.quantity?.classList.toggle('is-vanished', !available);
          this.buyNow?.classList.toggle('is-hidden', !available);
          this.setAddButtons(!available, available ? this.addText : this.soldoutText);
        }

        update() {
          this.updateAvailability();
          this.setVariant();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
